import setParamsByUser from 'utils/analytics/setParamsByUser';
import { getSessionType, userBasicGuard } from 'utils/clickme';
import { Permissions } from 'utils/constants/permissions';

import { Requirements } from 'app/routes';

import { setLoadUser, setSessionType, setUser, setUserPermissions, UserInfoDto, UserType } from 'store/models/user';

const SuperAdminRequirements: Requirements<{
    user: UserInfoDto;
}> = {
    methods: () => ({ user: { url: '/api/v1/user' } }),
    resolve: ({ result: { user }, state }) => {
        const { actualUser } = user;
        const permissions = [];
        if (user.user.userType !== UserType.SuperAdmin) {
            permissions.push(Permissions.ViewPersonalAreaSection);
        } else {
            permissions.push(
                Permissions.ViewAdminSection,
                Permissions.ViewAdminFullMenu,
                Permissions.ViewAdminReports,
                Permissions.ViewAdminBonusForm,
                Permissions.ViewAdminInvoiceDetailPage,
                Permissions.ViewModeration
            );
        }
        setParamsByUser(user.user, state.user.loginData);
        return [
            setUserPermissions(permissions),
            setLoadUser(false),
            setUser(user.user),
            setSessionType(getSessionType(actualUser)),
        ];
    },
    error: (err) => [setUserPermissions(userBasicGuard(err)), setLoadUser(false)],
};

export default SuperAdminRequirements;
